import SarasErpApi from '../../../helper/SarasErpApi';


var generateKeyParams = (masterKeys) => {
    if(masterKeys){
        if (masterKeys.compId) {
            return { wsId: masterKeys.wsId, dId: masterKeys.dId, 
                        dtId: masterKeys.dtId, compId: masterKeys.compId }
        }

        return { wsId: masterKeys.wsId, dId: masterKeys.dId, dtId: masterKeys.dtId }
    }
    else{
        return { wsId: '', dId: 0, dtId: 0 }
    }
}

/*******workflow Take action and Submit for Approval starts here*******/
const loadWorkflowSession = async function (masterKeys, onSuccessCallBack) {
    var action = "WrkFlwApv";
    var params = generateKeyParams(masterKeys);
    var requestObject = { ...params, actionName: action, actionId: "show" };

    const response = await SarasErpApi.post('core', requestObject);

    // console.log("response Object", requestObject);
    if (response) {
        if (onSuccessCallBack) onSuccessCallBack(response,requestObject);
    }
}

const submitForApproval = async function (masterKeys, onSuccessCallBack) {
    var action = "WrkFlwApv";
    var params = generateKeyParams(masterKeys);
    var requestObject = { ...params, actionName: action, actionId: "show", submitForApp: "1" };

    const response = await SarasErpApi.post('core', requestObject);

    // console.log("response Object", requestObject);
    if (response) {
        if (onSuccessCallBack) onSuccessCallBack(response,requestObject);
    }

}

const workFlowTracAction = async function (masterKeys, activityid, wrkflwactionid, onSuccessCallBack) {
    if (activityid) {
        var action = "WrkFlwApv";
        var params = generateKeyParams(masterKeys);
        var requestObject = { ...params, actionName: action, actionId: "review", activtyId: activityid, wrkflwactionid: wrkflwactionid };

        const response = await SarasErpApi.post('core', requestObject);

        // console.log("response Object", requestObject);
        if (response) {
            if (onSuccessCallBack) onSuccessCallBack(response,requestObject);
        }
    }
}

export { generateKeyParams, loadWorkflowSession, submitForApproval, workFlowTracAction };
